import {useState, useEffect} from 'react';
import axios from 'axios';
import { TableContainer } from "@mui/material";
import '../../Styles/Components/Persons/Preview_Person.css';
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import {useNavigate } from "react-router-dom";
import Config from '../PublicForms/Config.js';
import isTokenExpired from '../PublicForms/isTokenExpired.js';
import Navigation_Bar from "../PublicForms/Navigation_Bar.js";
import Header from "../PublicForms/Header.js";
import iconAdd from '../../Images/iconAdd.png';
import { ScrollToTop } from '../PublicForms/ScrollToTop.js';




export default function Add_New_City(props) {
  const [Provinces, setProvinces] = useState([]);
  const[provinceID,setProvinceID] = useState();
  const [provinceNameSrch, setProvinceNameSrch] = useState("");
  const [showTbl, setShowTbl] = useState(false);
  const [runProvinceUse, setRunProvinceUse] = useState(true);
  const [provinceName, setProvinceName] = useState("");
  const [cityName, setCityName] = useState("");
  const [runSaveData, setRunSaveData] = useState(false);
  const [data, setData] = useState([]);
  const[message, setMessage] = useState([]);
  const[messTitle, setMessTitle] = useState("");
  const[showDialog, setShowDialog] = useState(false);
  const [width, setWidth] = useState(0);
  const[openNav, setOpenNav] = useState(false);
  const Navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
    } else {
        // setUser(JSON.parse(localStorage.getItem('user')));
      }
    } else {
        Navigate("/login");
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    
    window.addEventListener("resize", handleResize)
    
    handleResize()
    
    
  }, []);


  useEffect(()=>
    {
      const getProvinces = async ()=>
      {
            axios.get(`${Config.apiBaseUrl}/api/Province?ProvinceName=${provinceNameSrch}`,{headers: {
         
              "Authorization":`Bearer ${localStorage.getItem('token')}`,
            }
          }).then(response => 
            {
                    if(response.status === 200)
                    {
                        setProvinces(response.data);
                        setRunProvinceUse(false);
                      //  setLoading(false);
                           
                    }else
                    {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("مجددا تلاش کنید"),      // append new element
                        ];
                    });
                     setShowDialog(true);
                    }
        
                }).catch((err) =>{
        
                  if(err.response !== null && err.response !== undefined)
                    {
                        setMessage([]);
                        if(err.response.status === 401)
                        {
                            Navigate("/login");
                        }else if((err.response.status) === 500)
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    (err.response.detail),      // append new element
                                ];
                            });
                            setShowDialog(true);
            
                        }else
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    "لطفا مجددا تلاش کنید",      // append new element
                                ];
                            });
                            setShowDialog(true);
                
                        }
            
                    }else if(err.message == "Network Error")
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                            ];
                        });
                        setShowDialog(true);
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
                });
              
            
              
      };
       
      if(runProvinceUse)
      {
        getProvinces();
        
      }
    
    },[runProvinceUse])
      

  
  const handleNave = ()=>
  {
      setOpenNav(!openNav);

  }

  const handleNaveForm = ()=>
  {
      if(!openNav)
      {
          setOpenNav(!openNav)
      }
  }

  const checkValidData = ()=>
    {
      
        setMessage([]);  

    if(provinceID === undefined || provinceID === null ||  provinceID === "")
      {
        setMessTitle("توجه");
        var mess = " لطفا نام استان را انتخاب کنید";
        var tempArr = message;
        tempArr.push(mess);
        setMessage(tempArr);
        setShowDialog(true);
      }

  
      if(cityName === undefined || cityName === null ||  cityName === "")
      {
        setMessTitle("توجه");
        var mess = " لطفا نام شهر را وارد کنید";
        var tempArr = message;
        tempArr.push(mess);
        setMessage(tempArr);
        setShowDialog(true);
      }else
      {

        setRunSaveData(true);

      }
  
  }

  useEffect(()=>
    {
     setMessage([]);
      const saveData = async ()=>
      {
        console.log(provinceID)
        axios.post(
          `${Config.apiBaseUrl}/api/Cities`,{
  
  
            "cityName": cityName,
            "provinceID": provinceID
    
          },{headers: {
         
            "Authorization":`Bearer ${localStorage.getItem('token')}`,
          }
        }).then(response => 
          {
              if(response.status == 201)
              {
                  setMessTitle("توجه");
                  setMessage((prevMessages) => {
                      return [
                        ...prevMessages, // shallow copy into new array reference
                        "نام شهر مورد نظر شما با موفقیت ثبت شد",      // append new element
                      ];
                    });
                  setShowDialog(true);
      
              }else
              {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                        ...prevMessages, // shallow copy into new array reference
                        "لطفا مجددا تلاش کنید",      // append new element
                      ];
                  });
                  setShowDialog(true);
              }
      
          }).catch((err) =>{
             
            if(err.response !== null && err.response !== undefined)
              {
                  setMessage([]);
                  if(err.response.status == 401)
                  {
                      Navigate("/login");
      
      
                  }else if((err.response.status)==500)
                  {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                (err.response.detail),      // append new element
                            ];
                        });
                        setShowDialog(true);
            
                  }else
                  {
                          setMessTitle("خطا");
                          setMessage((prevMessages) => {
                              return [
                                ...prevMessages, // shallow copy into new array reference
                                "لطفا مجددا تلاش کنید",      // append new element
                              ];
                          });
                          setShowDialog(true);
          
                  }
      
             }else if(err.message == "Network Error")
              {
                  setMessTitle("خطا");
                          setMessage((prevMessages) => {
                              return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                              ];
                          });
                          setShowDialog(true);
             }else
              {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                          ...prevMessages, // shallow copy into new array reference
                          ("لطفا مجددا تلاش کنید"),      // append new element
                      ];
                  });                
                  
                  setShowDialog(true);
             }
         })
  
      }
     
     if(runSaveData === true)
     {
      saveData();
      setRunSaveData(false);
  
     }
  
    },[runSaveData]);
  
  const closeOpenDialog = (open) =>
  {
        setMessage([]);
        setShowDialog(false);
          
  }

if(width>999)
{

      return (
        
        <div className='prevPerson' >
                      <ScrollToTop />

                  <Header />

                   <div className="navClass">
                            <Navigation_Bar />
                        
                   </div>
                      
                        
              <div className='prevPersonContainer'>
                      <div className='row'>
                          <div className='col-md-1'></div>

                          <div className='col-md-11 prevPersonForm'>
                            <div className="row">
                                <div className='col-sm-4 form-group'>
                                  <div style={{width:'100%'}}>

                                    <label>استان  &#9733;</label>
                                    <div className='citySearchForm'>
                                      <input type="text" className="form-control" id="city"  onClick={()=>setShowTbl(true)}  defaultValue={cityName} placeholder='جست جوی نام استان...'/>
                                      <div className='cityValues'>

                                        {
                                            showTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                          <table
                                            className="table table-condensed"
                                            style={{ textAlign: "right", padding:'5%' }}
                                            
                                          >
                                            
                                            <tbody >            
                                            
                                              {Provinces?.map((pr,index) => {
                                                return (
                                                  <tr key={index} onClick={()=>{
                                                    // setRunSetValueData(true)
                                                    // setValueData(ct.cityID,6);
                                                    setProvinceID(pr.provinceID);
                                                    console.log(pr.provinceID)
                                                    setProvinceName(pr.provinceName);
                                                  }}>
                                                    <td>{provinceID == pr.provinceID ? <>&#x2713;</>:<></>}</td>                                          
                                                    <td >
                                                      {pr.provinceName}
                                                    </td>
                                                    
                                                  </tr>
                                                
                                                );
                                                })
                                              }
                                            
                                            </tbody>
                                          </table> 

                                        </TableContainer>
                                        : null
                                        }
                                        

                                      </div>
                                    </div>

                                    <div className='imgAddCity' onClick={()=>Navigate(`/settings/previewProvinces/تنظیمات/newProvince/0`)}>
                                            <img src={iconAdd} />
                                    </div>
          
                                  </div>

                                </div>
                                <div className="col-md-4 form-group">
                                          <label htmlFor="name"> نام شهر:</label>
                                          <input type="text" className="form-control" id="name" onChange={(e)=> setCityName(e.target.value)} />
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className='buttonContainer'>

                        <button type="button" autoFocus onClick={()=>checkValidData()}>
                          ثبت
                        </button>
                      
                      </div>
                {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
              </div>
            </div>

    );

}else
{
      return (
        <div className='prevPerson-all-responsive'>

          <div className= {openNav? "navClass" : "navClass navClassOpen"}>                                

            <Navigation_Bar />
                              
          </div>
            
           <div className='prevPerson' >
              
                  <Header handleNave={handleNave}/>

                  
              <div className='prevPersonContainer' onClick={()=>handleNaveForm()}>
                         

                      <div className='prevPersonForm'>
                        <div className="row">
                            <div className='col-sm-6 col-md-6 form-group'>
                              <div style={{width:'100%'}}>

                                <label>استان  &#9733;</label>
                                <div className='citySearchForm'>
                                  <input type="text" className="form-control" id="city"  onClick={()=>setShowTbl(true)}  defaultValue={cityName} placeholder='جست جوی نام استان...'/>
                                  <div className='cityValues'>

                                    {
                                        showTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                      <table
                                        className="table table-condensed"
                                        style={{ textAlign: "right", padding:'5%' }}
                                        
                                      >
                                        
                                        <tbody >            
                                        
                                          {Provinces?.map((pr,index) => {
                                            return (
                                              <tr key={index} onClick={()=>{
                                                // setRunSetValueData(true)
                                                // setValueData(ct.cityID,6);
                                                setProvinceName(pr.provinceName);
                                              }}>
                                        
                                                <td >
                                                  {pr.provinceName}
                                                </td>
                                                
                                              </tr>
                                            
                                            );
                                            })
                                          }
                                        
                                        </tbody>
                                      </table> 

                                    </TableContainer>
                                    : null
                                    }
                                    

                                  </div>
                                </div>

                                <div className='imgAddCity' onClick={()=>Navigate(`/settings/previewProvinces/تنظیمات/newProvince/0`)}>
                                        <img src={iconAdd} />
                                </div>
      
                              </div>

                            </div>
                            <div className="col-sm-6 form-group">
                                      <label htmlFor="name"> نام شهر:</label>
                                      <input type="text" className="form-control" id="name" onChange={(e)=> setProvinceName(e.target.value)} />
                              </div>
                          </div>
                      </div>
                      <div className='buttonContainer'>
  
                        <button type="button" autoFocus onClick={()=>checkValidData()}>
                          ثبت
                        </button>
                      
                      </div>
                {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
              </div>
            </div>
        </div>

    );
}
  
  
}
